module.exports = __webpack_public_path__ + "static/media/artist_dron-z_w.856e121b.png";